//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  signal,
  WritableSignal,
} from "@angular/core";
import { 
  ActivatedRoute, 
  Router 
} from "@angular/router";

//local imports
import { CatalogConstants, DepartmentModel, ProjectModel } from "@app/catalog";
import { SearchModel } from "@app/core";
import { BreadcrumbChangedMessage, BreadcrumbItemToggleMessage, Messenger, PresenterType } from "@app/shared";

@PresenterType({
  model: DepartmentModel,
  key: 'tileBottom'
})
@Component({
  selector: 'department-carousel-item-bottom',
  standalone: false,
  templateUrl: './department-carousel-item-bottom.component.html',
  styleUrl: './department-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartmentCarouselItemBottomComponent implements OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private selectedDepartments: DepartmentModel[] = [];
  private selectedProjects: ProjectModel[] = [];
  private searchItems = [];

  public data: WritableSignal<DepartmentModel> =
    signal<DepartmentModel>(undefined);


  constructor(
    private messenger: Messenger,
  ) {
    this.messenger.subscribe(this, BreadcrumbChangedMessage, (message) => {
        if(message.breadcrumbName !== CatalogConstants.CATALOG) { 
            return;
        }
        message.breadcrumbs.forEach((item) => {

          if(item instanceof SearchModel) {
            const exists = this.searchItems.some(search => search.id === item.id);
            if (!exists) { 
            this.searchItems.push(item);
            }
          }

          if(item instanceof DepartmentModel) {
            const exists = this.selectedDepartments.some(department => department.id === item.id);
            if (!exists) {
              this.selectedDepartments.push(item);
            }
          } else if(item instanceof ProjectModel) {
            const exists = this.selectedProjects.some(project => project.id === item.id);
            if (!exists) {
              this.selectedProjects.push(item);
            }
          }
        })
    });
  }

  public navigateToDetailPage() {
    const currentDepartment = this.data();

    this.searchItems.forEach((searchItem) => {
      this.messenger.send(new BreadcrumbItemToggleMessage(searchItem, CatalogConstants.CATALOG));
    });
    
  
    const isAlreadySelected = this.selectedDepartments.some(department => department.id === currentDepartment.id);
    if (!isAlreadySelected) {
      this.messenger.send(new BreadcrumbItemToggleMessage(currentDepartment, CatalogConstants.CATALOG));
    }

    const currentParams = this.route.snapshot.queryParams;

    const queryParams = {
      ...currentParams,
      departmentId: currentDepartment.id
    }

    this.router.navigate(["/catalog/department", currentDepartment.id], {
      relativeTo: this.route,
      queryParams
    });
  }

  ngOnDestroy() {
    this.messenger.unsubscribeByOwner(this);
  }
}
